import { Badge } from "@/core/components/ui/badge";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { formatMoneyCents } from "@/core/utils/money";

interface TechnicianAdjustmentLineProps {
  jobNumber: string | null;
  amountCents: number;
  category: string;
  memo: string | null;
  alreadyPushed?: boolean;
}

export const TechnicianAdjustmentLine = ({
  jobNumber,
  amountCents,
  category,
  memo,
  alreadyPushed = false,
}: TechnicianAdjustmentLineProps) => (
  <Stack
    gap="xs"
    fullWidth
    className="border-b border-stroke-tertiary pb-3 last:border-0"
  >
    <Stack direction="row" align="center" justify="between" gap="sm">
      <Typography variant="bodyW2" className="font-medium">
        {jobNumber ? `Job ${jobNumber}` : "No job number"}
      </Typography>
      <Typography variant="bodyW2" className="shrink-0 font-medium">
        {formatMoneyCents(amountCents) ?? "$0"}
      </Typography>
    </Stack>
    <Stack direction="row" align="center" gap="sm">
      <Typography
        variant="captionW1"
        textColor="secondary"
        className="capitalize"
      >
        {category.replace(/_/g, " ")}
      </Typography>
      {alreadyPushed && (
        <Badge variant="gold" size="sm">
          Pushed
        </Badge>
      )}
    </Stack>
    {memo && (
      <Typography
        variant="captionW1"
        textColor="tertiary"
        className="break-words"
      >
        {memo}
      </Typography>
    )}
  </Stack>
);
